import React, {useEffect} from 'react';

const Loader = () => {

	useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => (document.body.style.overflow = "unset");
    });

	return(
		<div className="loader">
			<div className="dots" />
			<div className="dots" />
			<div className="dots" />
			<div className="dots" />
			<div className="dots" />
		</div>
	);
};

export default Loader;
